import React, { useState, useEffect } from 'react';
import {
  Button,
  IconButton,
  Typography,
  Grid,
  Box,
  Tooltip
} from "@mui/material";
import { useSnackbar } from 'notistack';
import { ACTIONS, MESSAGES } from '../../shared/constants';
import DataTable from '../../shared/data-table';
import {
  GetDataAbsenteeismIssuer,
  GetDataDetailAbsenteeisms,
  GetDataAllAbsenteeismSupport,
  DeleteAbsenteeismSupport,
  saveAbsenteeismSupport
} from './logic';
//import ProfileTypeDetails from '../../Profile-type/Profile-type-detail';
import AbsenteeismSupportDetail from './AbsenteeismSupport-Detail';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircle from '@mui/icons-material/AddCircle';
import ErrorSnackbar from '../error-snackbar';
import BackDrop from '../../shared/backdropDE';
import { getUser } from '../../shared/auth-service';
import AlertDialogQuestion from '../alert-dialog-question';
import { GetAllTypeAbsenteeisms } from '../../shared/data-services/AbsenteeismSupport-Service';

const AbsenteeismSupport = () => {
  const [loading, setLoading] = useState(true);
  const user = getUser();
  const [data, setData] = useState(null);
  const [absenteeismIssuer, setAbsenteeismIssuer] = useState(null);
  const [detailAbsenteeism, setDetailAbsenteeism] = useState(null);
  const [typeAbsenteeism, setTypeAbsenteeism] = useState(null);
  const [id, setId] = useState(null);
  const [showModal, setShowModal] = useState(null);
  const [action, setAction] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const [error, setError] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [uniquePositions, setUniquePositions] = useState([]);
  const [alertQuestionOpen, setAlertQuestionOpen] = useState(false);
  const [idDelete, setIdDelete] = useState(null);
  const companyId = user.countryCode.split('-')[0];
  const temporalId = user.temporalId;
  const employeeId = user.employeeId;



  useEffect(() => {
    async function fetchData() {
      if (loading) {
        try {
          const dataAll = await GetDataAllAbsenteeismSupport(employeeId, companyId, temporalId);         
          const dataAbsenteeismIssuer = await GetDataAbsenteeismIssuer();
          const dataDetailAbsenteeism = await GetDataDetailAbsenteeisms();
          const dataTypeAbsenteeism = await GetAllTypeAbsenteeisms();

          setAbsenteeismIssuer(dataAbsenteeismIssuer);
          setDetailAbsenteeism(dataDetailAbsenteeism);
          setTypeAbsenteeism(dataTypeAbsenteeism)

          setLoading(false);
          setData(dataAll);
          setPermissions(permissions);

        } catch (error) {
          setError(error.message);
          setLoading(false);
          setData([]);
        }
      }
    }
    fetchData();
  }, [loading]);

  useEffect(() => {
    if (data) {
      setUniquePositions(getUniquePositions(data));
    }
  }, [data]);

  const getUniquePositions = (data) => {
    const unique = {};
    data.forEach((item) => {
      if (!unique[item.profile]) {
        unique[item.profile] = item;
      }
    });
    return Object.values(unique);
  };

  const getRowId = (row) => row.id;

  const handleDeleteData = async (cellValues) => {
    setAlertQuestionOpen(true);
    setIdDelete(cellValues.row.id);
  };

  const handleCloseAlert = () => {
    setAlertQuestionOpen(false);
    setIdDelete(null);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleSave = async (data) => {
    try {
      const response = await saveAbsenteeismSupport(data);
  
      if (response.data.status) {
        enqueueSnackbar(response.data.message || "Registro guardado correctamente.", { variant: 'success' });
        setShowModal(false);
        setLoading(true);
      } else {
        enqueueSnackbar(response.data.message || "No se pudo guardar el registro.", { variant: 'warning' });
      }
    } catch (error) {
      enqueueSnackbar("Error al guardar el registro.", { variant: 'error' });
    }
  };

  const handleDelete = async () => {
    //console.log(id);
    await DeleteAbsenteeismSupport(idDelete, employeeId);
    setShowModal(false);
    setAlertQuestionOpen(false);
    setLoading(true);
    enqueueSnackbar(MESSAGES.DELETE);
  };

  const handleNew = async () => {
    setId(null);
    setShowModal(true);
    setAction(ACTIONS.NEW);
  };

  const columns = [
   // { field: 'id', headerName: 'Id', miwidth: 25, flex: 0.05},
    { field: 'employeeId', headerName: 'Identificación', minWidth: 110 },
    { field: 'employeeName', headerName: 'Nombre Completo', minWidth: 250},
    { field: 'empresa', headerName: 'Compañía', minWidth: 50},
    { field: 'cargo', headerName: 'Cargo', minWidth: 250 },
    { field: 'fechaIngreso', headerName: 'Fecha Ingreso', minWidth: 120},
    { field: 'area', headerName: 'Área', minWidth: 50 },
    { field: 'centroCosto', headerName: 'Centro Costo', minWidth: 110 },
    { field: 'startDate', headerName: 'Fecha Desde', minWidth: 100},
    { field: 'endDate', headerName: 'Fecha Hasta', minWidth: 100},
    { field: 'cantidadDias', 
      headerName: 'Días', 
      minWidth: 50, 
      align : 'center'
    },
    { 
      field: 'typeAbsenteeism', 
      headerName: 'Tipo Ausentismo', 
      minWidth: 130, 
      valueGetter: (params) => params.row.typeAbsenteeism?.description || '' 
    },
    { 
      field: 'detailAbsenteeism', 
      headerName: 'Detalle Ausentismo', 
      minWidth: 150, 
      valueGetter: (params) => params.row.detailAbsenteeism?.description || '' 
    },
    { 
      field: 'absenteeismIssuer', 
      headerName: 'Entidad que Emite', 
      minWidth: 120, 
      valueGetter: (params) => params.row.absenteeismIssuer?.description || '' 
    },
    {
      field: 'codeCIE',
      headerName: 'Código CIE',
      minWidth: 250,
      renderCell: (params) => (
        <Tooltip title={(params.row.codeCIE?.code && params.row.codeCIE?.description) ? `${params.row.codeCIE.code}-${params.row.codeCIE.description}` : ''} arrow>
          <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%' }}>
            {(params.row.codeCIE?.code && params.row.codeCIE?.description) ? `${params.row.codeCIE.code}-${params.row.codeCIE.description}` : ''}
          </span>
        </Tooltip>
      )
    },    
    {
      field: "Borrar",
      headerName: "Borrar",
      width: 60,
      sortable: false,
      renderCell: (cellValues) => {
        return <IconButton
          aria-label="delete"
          color="error"
          onClick={() => { handleDeleteData(cellValues) }}
        >
          <DeleteIcon />
        </IconButton>;
      }
    }
  ];

  if (loading) {
    return (
      // <Box sx={{ display: 'flex' }}>
      //     <CircularProgress />
      // </Box>
      <BackDrop />
    );
  }

  if (error) {
    return (<ErrorSnackbar message={error} />);
  }

  return (
    <>
      {showModal && <AbsenteeismSupportDetail
          dataAbsenteeismIssuer={absenteeismIssuer}
          dataDetailAbsenteeism={detailAbsenteeism}
          dataTypeAbsenteeism={typeAbsenteeism}
          handleClose={handleCloseModal}
          handleSave={handleSave}
      />}

      {alertQuestionOpen && <AlertDialogQuestion
        handlePositive={handleDelete}
        handleNegative={handleCloseAlert}
        textButtonPositive={ACTIONS.ACCEPT}
        textButtonNegative={ACTIONS.CANCEL}
        dialogContentText={MESSAGES.CONFIRM_DELETE}
        dialogTitle={""}
        open={alertQuestionOpen}
        elemento={""}
      />}

      <Grid container spacing={2}>
        <Grid item xs={10}>
          <Typography variant="h5" style={{ color: '#1a3072' }} fontWeight="bold" sx={{ flexGrow: 1, m: 1, }}>
            Soporte de <span style={{ color: '#00b0ef' }}>Ausentismos</span>
          </Typography>
          {/* <Typography variant="h5" gutterBottom>
                {`${TITLES.Profile_TYPE}`}
              </Typography> */}
        </Grid>
        <Box sx={{ m: 4 }}>
          <Grid item xs={2}>
            <Button
              endIcon={<AddCircle />}
              variant="contained"
              onClick={() => { handleNew() }} autoFocus>{ACTIONS.NEW}</Button>
          </Grid>
        </Box>
      </Grid>
      <DataTable 
          columns={columns} 
          rows={data} 
          sx={{
            '& .MuiDataGrid-columnHeaderTitle': {
              fontWeight: 'bold',
            }
          }}
        />
    </>
  );
};

export default AbsenteeismSupport;
